import React, { ReactNode } from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import { RmxArrowBackIcon } from 'cokitchen-icons';

type Props = {
  children: ReactNode;
  noOfSteps?: number;
  step: number;
  setStep: (item: number) => void;
  handleConfirmClick: () => void;
  handleCancelClick?: () => void;
  onNextClick?: () => void;
  title?: string;
  disabled: boolean;
  subtitle?: string;
  hideSteps?: boolean;
  loading?: boolean;
  hidePrimaryAction?: boolean;
};
const FormStepper = ({
  children,
  noOfSteps = 2,
  step,
  title,
  setStep,
  handleConfirmClick,
  handleCancelClick,
  onNextClick,
  disabled,
  subtitle,
  hideSteps,
  loading,
  hidePrimaryAction
}: Props) => {
  const handlePrevClick = () => {
    if (step === 1) return;
    setStep(step - 1);
  };
  const handleNextClick = () => {
    onNextClick?.();
    if (step === noOfSteps) {
      handleConfirmClick();
    } else {
      setStep(step + 1);
    }
  };

  const generateArrayOfNos = () => {
    const arr: number[] = [];
    for (let i = 1; i < noOfSteps + 1; i++) {
      arr.push(i);
    }
    return arr;
  };

  return (
    <div className='flex flex-col max-h-screen'>
      {!hideSteps && (
        <div>
          <label className='text-gray-9 text-xs'>
            Step {step}/{noOfSteps}
          </label>

          <div className='my-2  flex items-center justify-between'>
            {generateArrayOfNos()?.map((no) => (
              <div
                className={`w-[50%] mr-1 md:min-w-[220px] h-[7px] rounded-sm transition-all duration-500 delay-100  ${
                  step >= no ? 'bg-red-5 ' : 'bg-[#EDE8E8]'
                }`}
                key={no}
              />
            ))}
          </div>
        </div>
      )}
      <div className='bg-[#F7F7F8] w-full p-1 overflow-y-auto justify-center items-center rounded-md'>
        <div className='bg-white w-full h-auto rounded-md py-6'>
          {title && (
            <p className={`px-4 md:px-7 font-semibold font-2xl ${!subtitle && 'pb-[30px]'}`}>
              {title}
            </p>
          )}
          {subtitle && <p className='px-4 md:px-7 text-[#6F7376] text-sm pb-[30px]'>{subtitle}</p>}
          <div className='px-4 md:px-7 pb-6'>{children}</div>
          <div className='flex gap-6 pt-7 px-4 md:px-7  items-center justify-between border-t-2 border-t-[#F7F7F8] w-full flex-wrap-reverse'>
            {step !== 1 && (
              <div className='flex items-center gap-3 cursor-pointer' onClick={handlePrevClick}>
                <div className='flex w-[30px] h-[30px] bg-[#F4F5F5] rounded-full justify-center items-center'>
                  <RmxArrowBackIcon className='text-gray-9' />
                </div>
                <p className='text-sm text-gray-10'>Back</p>
              </div>
            )}
            <div className='flex gap-6 items-center justify-end ml-auto'>
              {step == 1 && (
                <Button variant='link' color='gray' small onClick={handleCancelClick}>
                  Cancel
                </Button>
              )}
              {!hidePrimaryAction && (
                <Button
                  variant='block'
                  color='primary'
                  loading={loading}
                  small
                  className='w-[153px] h-[43px]'
                  disabled={disabled}
                  onClick={handleNextClick}>
                  {step === noOfSteps ? 'Confirm' : 'Continue'}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormStepper;
